import { StartOrderRequest } from 'type';
import { cloud, local } from './appconstants';

export const vehicleQuotationEndpoint =
  process.env.REACT_APP_ENV === local
    ? process.env.REACT_APP_API_ENDPOINT
    : window.GLOBAL_STATE.configure.initialValuesApi;

const imageServiceEndpoint =
  process.env.REACT_APP_ENV === local
    ? process.env.REACT_APP_API_IMAGE_ENDPOINT
    : `${window.GLOBAL_STATE.configure.vehicleImageServiceApi}`;

const siteCoreEndpoint =
  process.env.REACT_APP_ENV !== cloud
    ? process.env.REACT_APP_API_ENDPOINT
    : window.GLOBAL_STATE.configure.sitecoreApi ?? '/api';

const reviewServiceEndpoint =
  process.env.REACT_APP_ENV !== cloud
    ? process.env.REACT_APP_API_VEHICLE_REVIEW_ENDPOINT
    : `${window.GLOBAL_STATE.configure.vehicleReviewScoreApi}`;

const imageServiceUrl = `${imageServiceEndpoint}/vehicle`;
const siteCoreVehiclesUrl = `${siteCoreEndpoint}/leaseconfiguratorvehicledata/vehicles`;
const siteCoreConfigUrl = `${siteCoreEndpoint}/leaseconfiguratorconfig/content`;
const vehicleReviewScoreUrl = `${reviewServiceEndpoint}/reviews`;

const vehicleImageDefaultPositionInArray =
  `${window.GLOBAL_STATE.configure.defaultImageArrayIndex}` || 2;

export const APIM_PUBLIC_SUBSCRIPTION_KEY = () =>
  process.env.REACT_APP_ENV === local
    ? process.env.REACT_APP_APIM_PUBLIC_SUBSCRIPTION_KEY
    : `${window.GLOBAL_STATE.configure.APIMPublicSubscriptionKey}`;

export const GET_ALL_VEHICLES = () => `${vehicleQuotationEndpoint}/vehicles`;

export const GET_VEHICLE_IMAGE = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) =>
  `${imageServiceUrl}/gallery/${modelCode}/${vehicleImageDefaultPositionInArray}?trim=${trim}&train=${train}&doors=${doors}&modelyear=${year}`;

export const GET_VEHICLE_SITECORE_DETAILS = (id: number) =>
  `${siteCoreVehiclesUrl}/${id}`;

export const CREATE_QUOTATION = () => '/api/orders/createQuotation';

export const START_ORDER = (startOrderRequest: StartOrderRequest) => {
  const optionsSelectedQueryParam = startOrderRequest.selectedOptions
    ? startOrderRequest.selectedOptions
        .map((param) => `&SelectedOptions=${param}`)
        .join('')
    : '';

  return `/api/orders/startOrder?vehicleId=${startOrderRequest.vehicleId}&Duration=${startOrderRequest.duration}&AnnualMileage=${startOrderRequest.annualMileage}&InitialPayment=${startOrderRequest.initialPayment}&IncludeMaintenance=${startOrderRequest.includeMaintenance}${optionsSelectedQueryParam}&IsBusinessOrder=${startOrderRequest.isBusinessOrder}`;
};

export const SAVE_QUOTE = () => '/api/showroom/saveQuote';

export const GET_VEHICLE_IMAGES = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) =>
  `${imageServiceUrl}/gallery?capModelCode=${modelCode}&trim=${trim}&train=${train}&doors=${doors}&modelyear=${year}`;

export const GET_SITECORE_COMPONENTS = () => `${siteCoreConfigUrl}`;

export const GET_VEHICLE_COLOURS = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) =>
  `${imageServiceUrl}/colours?capModelCode=${modelCode}&trim=${trim}&train=${train}&doors=${doors}&modelyear=${year}`;

export const EXT_360 = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) =>
  `${imageServiceUrl}/external360?capModelCode=${modelCode}&trim=${trim}&train=${train}&doors=${doors}&modelyear=${year}`;

export const INT_360 = (
  modelCode: number | undefined,
  doors: number | undefined,
  trim: string | undefined,
  train: string | undefined,
  year: string | undefined
) =>
  `${imageServiceUrl}/internal360?capModelCode=${modelCode}&trim=${trim}&train=${train}&doors=${doors}&modelyear=${year}`;

export const GET_VEHICLE_REVIEW_SCORE = (capId: string | undefined) => {
  return `${vehicleReviewScoreUrl}/${capId}/score`;
};

export const apiConfig = {
  headers: {
    'Ocp-Apim-Subscription-Key': APIM_PUBLIC_SUBSCRIPTION_KEY() || '',
  },
};

export const appInsightsInstrumentationKey =
  process.env.REACT_APP_ENV === local
    ? process.env.REACT_APP_INSIGHTS_INSTRUMENTATION_KEY
    : window.GLOBAL_STATE.configure.appInsightsInstrumentationKey;
